import { searchCommonConfig } from './common'

/**
 * Rocnovel 品牌搜索页面配置
 */
export const searchConfig = {
  ...searchCommonConfig,
  colors: {
    inputBg: '#0000000A',
    startReadingBg: 'linear-gradient(90deg, #FF6E0F 0%, #FF5970 100%)',
  },
}
